import React from "react";
import SaveButton from "./SaveButton";
import CancelButton from "./CancelButton";
import "../../styles/FormCard.css";

const FormActions = ({ onCancel, onSave, saveText = "Enregistrer", isLoading = false, disabled = false, extraActions }) => {
  return (
    <div className="form-actions">
      {extraActions && <div className="form-actions-extra">{extraActions}</div>}
      <CancelButton onClick={onCancel} disabled={isLoading} />
      <SaveButton onClick={onSave} text={saveText} isLoading={isLoading} disabled={disabled} />
    </div>
  );
};

export default FormActions;
